import { render } from "./ShopProduct.vue?vue&type=template&id=64ba791a&scoped=true&bindings={\"product\":\"data\",\"products\":\"options\"}"
import script from "./ShopProduct.vue?vue&type=script&lang=js"
export * from "./ShopProduct.vue?vue&type=script&lang=js"

import "./ShopProduct.vue?vue&type=style&index=0&id=64ba791a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64ba791a"

export default script